export default [{
		path: '/',
		name: '',
		component: resolve => require(['@/views/home'], resolve),
		children: [
		{
			path: 'expert',
			name: '专家外审 ',
			meta: {
				title: '专家外审'
			},
			component: resolve => require(['../views/expert/index.vue'], resolve),
		},
		{
			path: '/manage/doubleCheck',
			name: '稿件查重',
			meta: {
				title: '稿件查重'
			},
			component: resolve => require(['../views/manage/doubleCheck/index.vue'], resolve),
		},
		{
			path: '/manage/rehearing',
			name: '稿件复审',
			meta: {
				title: '稿件复审'
			},
			component: resolve => require(['../views/manage/rehearing/index.vue'], resolve),
		},
		{
			path: '/manage/auditTemplate',
			name: '审核模板',
			meta: {
				title: '审核模板'
			},
			component: resolve => require(['../views/manage/rehearing/auditTemplate.vue'], resolve),
		},
		{
			path: '/manage/finalJudgment',
			name: '稿件终审',
			meta: {
				title: '稿件终审'
			},
			component: resolve => require(['../views/manage/finalJudgment/index.vue'], resolve),
		},
		{
			path: '/manage/screeningDraft',
			name: '筛稿',
			meta: {
				title: '筛稿'
			},
			component: resolve => require(['../views/manage/screeningDraft/index.vue'], resolve),
		},
	]

	},

]


// WEBPACK FOOTER //
// ./src/router/expert_routers.js